import React from 'react';
import { FaTint, FaUser, FaChevronDown } from 'react-icons/fa';
import { NavButton, MobileNavButton } from './NavButtons';

export const Navbar = ({ scrolled, view, changeView, mobileMenuOpen, setMobileMenuOpen }) => (
  <nav
    className={`fixed top-0 w-full z-50 transition-all duration-500 ${scrolled || (view !== "inicio" && view !== "login") ? "bg-blue-900 border-b border-blue-700 shadow-2xl py-3" : view === "login" ? "bg-transparent py-4" : "bg-white/5 backdrop-blur-md border-b border-white/20 py-4"}`}
  >
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center justify-between h-16">
      <div
        className="flex items-center gap-2 cursor-pointer group"
        onClick={() => changeView("inicio")}
      >
        <div className="bg-blue-600 p-2 rounded-xl shadow-lg group-hover:scale-110 transition-transform">
          <FaTint className="text-white text-xl" />
        </div>
        <span
          className={`font-black text-2xl tracking-wider uppercase transition-colors ${view === "login" ? "text-blue-900 lg:text-white" : "text-white"}`}
        >
          Aqua<span className="text-cyan-400">Gestión</span>
        </span>
      </div>
      <div className="hidden lg:flex items-center space-x-1">
        <NavButton
          active={view === "inicio"}
          onClick={() => changeView("inicio")}
          label="Inicio"
          light={view !== "login"}
        />
        <NavButton
          active={view === "nosotros"}
          onClick={() => changeView("nosotros")}
          label="Institucional"
          light={view !== "login"}
        />
        <NavButton
          active={view === "consultas"}
          onClick={() => changeView("consultas")}
          label="Portal de Pagos"
          light={view !== "login"}
        />
        <NavButton
          active={view === "como-funciona"}
          onClick={() => changeView("como-funciona")}
          label="Cómo Funciona"
          light={view !== "login"}
        />
        <div
          className={`w-px h-6 mx-4 transition-colors ${view === "login" ? "bg-gray-200 lg:bg-white/20" : "bg-white/20"}`}
        ></div>
        <button
          onClick={() => changeView("login")}
          className={`flex items-center justify-center font-medium transition-all group w-10 h-10 rounded-full ${view === "login" ? "bg-blue-900 text-white shadow-lg scale-110" : "bg-white/10 text-blue-100 hover:text-white hover:bg-white/20 hover:scale-105"}`}
          title="Acceso Administrativo"
        >
          <FaUser className={view === "login" ? "text-lg" : "text-sm"} />
        </button>
      </div>
      <div className="lg:hidden">
        <button
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          className={`p-2 rounded-lg transition-colors ${view === "login" ? "bg-gray-100 text-gray-800" : "text-white bg-white/10"}`}
        >
          <FaChevronDown
            className={`transition-transform duration-500 ${mobileMenuOpen ? "rotate-180" : ""}`}
          />
        </button>
      </div>
    </div>
    {mobileMenuOpen && (
      <div className="lg:hidden bg-blue-950 border-t border-blue-800 animate-fade-in flex flex-col p-6 space-y-4 shadow-2xl">
        <MobileNavButton
          active={view === "inicio"}
          onClick={() => changeView("inicio")}
          label="Inicio"
        />
        <MobileNavButton
          active={view === "nosotros"}
          onClick={() => changeView("nosotros")}
          label="Quiénes Somos"
        />
        <MobileNavButton
          active={view === "consultas"}
          onClick={() => changeView("consultas")}
          label="Consultar Deuda"
        />
        <MobileNavButton
          active={view === "como-funciona"}
          onClick={() => changeView("como-funciona")}
          label="Cómo Funciona"
        />
        <button
          onClick={() => changeView("login")}
          className={`flex items-center justify-center p-4 rounded-2xl font-black transition-all ${view === "login" ? "bg-cyan-400 text-blue-900 shadow-xl" : "bg-white/10 text-white"}`}
        >
          <FaUser className="text-xl" />
        </button>
      </div>
    )}
  </nav>
);
